import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "text-black fw-semibold" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4 mb-2" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-4 mb-2" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_13 = { class: "col-md-4 mb-2" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-md-4 mb-2" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-md-4 mb-2" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = { class: "col-md-4 mb-2" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-12 m-10" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "border border-primary mb-10" }
const _hoisted_25 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_26 = { class: "col-md-5" }
const _hoisted_27 = { class: "d-flex float-end" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "col-md-5 mb-2" }
const _hoisted_30 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_31 = { class: "col-md-2 mb-2" }
const _hoisted_32 = { class: "input-group" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "input-group-text" }
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = { class: "col-md-3 mb-2" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { class: "col mb-2" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_41 = { class: "col-auto mb-2" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "col-md-12 mt-3" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "Modification de la commande fournisseur " + _toDisplayString(_ctx.refCom), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.modifierCommande,
        "validation-schema": _ctx.commandeSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Date Com Four. "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "dateOperation",
                      modelValue: _ctx.dateOperation,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOperation) = $event)),
                      type: "datetime-local",
                      max: _ctx.currentDateTime,
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Date oper."
                    }, null, 8, ["modelValue", "max"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateOperation",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Fournisseur "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Multiselect, {
                      options: _ctx.fournisseurOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.fournisseur,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fournisseur) = $event)),
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.fournisseurError = ''))
                      ],
                      placeholder: "Sélectionner le fournisseur"
                    }, null, 8, ["options", "modelValue"]),
                    (_ctx.fournisseurError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.fournisseurError), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Poids total ", -1)),
                    _createVNode(_component_Field, {
                      name: "poidsTotal",
                      type: "number",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Poids total calculé",
                      modelValue: _ctx.poidsTotal,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.poidsTotal) = $event)),
                      readonly: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nom du conducteur ", -1)),
                    _createVNode(_component_Field, {
                      name: "nomConducteur",
                      modelValue: _ctx.nomConducteur,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nomConducteur) = $event)),
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Nom du conducteur"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomConducteur",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone du conducteur ", -1)),
                    _createVNode(_component_Field, {
                      name: "telephoneConducteur",
                      modelValue: _ctx.telephoneConducteur,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telephoneConducteur) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, _mergeProps({
                          placeholder: "Entrer le numéro de téléphone",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: _ctx.validate,
                          class: "shadow-none fs-md-15 text-black py-2"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.telephoneConducteur && !_ctx.validPhone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Veuillez entrer un numéro correct "))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephoneConducteur",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " N° d'immatriculation du véhicule ", -1)),
                    _createVNode(_component_Field, {
                      name: "immatriculationVehicule",
                      modelValue: _ctx.immatriculationVehicule,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.immatriculationVehicule) = $event)),
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Immatriculation du véhicule"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "immatriculationVehicule",
                      class: "text-danger"
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-7" }, [
                      _createElementVNode("h4", { class: "fs-4 text-white" }, "Les produits")
                    ], -1)),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                          type: "button",
                          disabled: _ctx.isDisable,
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addRowProduit()))
                        }, _cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                          _createTextVNode(" Ajouter un produit ")
                        ]), 10, _hoisted_28)
                      ])
                    ])
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row gx-2 mt-2 fw-semibold" }, [
                    _createElementVNode("div", { class: "col-md-5" }, [
                      _createTextVNode("Produit "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createTextVNode("Quantité "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ]),
                    _createElementVNode("div", { class: "col-md-3" }, "Description"),
                    _createElementVNode("div", { class: "col" }, "Poids(KG)"),
                    _createElementVNode("div", { class: "col-auto" })
                  ], -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "mt-1" }, null, -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row gx-2",
                      key: produitIndex
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_Multiselect, {
                          modelValue: produit.produit,
                          "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                          options: _ctx.listeProduitDisponible(produitIndex),
                          searchable: true,
                          placeholder: "Sélectionner un produit",
                          onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit)),
                          class: _normalizeClass(_ctx.validateRowProduit(produit.produit)
                                                ? 'fs-md-15 text-black is-invalid'
                                                : 'fs-md-15 text-black')
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onSelect", "class"]),
                        (_ctx.validateRowProduit(produit.produit))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Le produit est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((produit.qteBon) = $event),
                            class: _normalizeClass(_ctx.validateRowProduit(produit.qteBon)
                                                ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                                : 'form-control shadow-none fs-md-15 text-black'),
                            placeholder: "Quantité"
                          }, null, 10, _hoisted_33), [
                            [_vModelText, produit.qteBon]
                          ]),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(produit.uniteMesure != null
                                                    ? produit.uniteMesure.replace("[", "").replace("]", "")
                                                    : 'UM'), 1)
                        ]),
                        (_ctx.validateRowProduit(produit.qteBon))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, " La quantité est obligatoire. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((produit.description) = $event),
                          rows: "1",
                          class: "form-control shadow-none fs-md-15 text-black description-textarea",
                          placeholder: "Description"
                        }, null, 8, _hoisted_37), [
                          [_vModelText, produit.description]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "0",
                          step: "any",
                          "onUpdate:modelValue": ($event: any) => ((produit.poids) = $event),
                          class: _normalizeClass(_ctx.poidsInvalide(produit.poids)
                                            ? 'form-control shadow-none fs-md-15 text-black is-invalid'
                                            : 'form-control shadow-none fs-md-15 text-black'),
                          placeholder: "Poids"
                        }, null, 10, _hoisted_39), [
                          [_vModelText, produit.poids]
                        ]),
                        (_ctx.poidsInvalide(produit.poids))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Le poids doit être positif. "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("button", {
                          class: "btn btn-danger transition border-0 pb-2 px-2",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeRowProduit(produitIndex))
                        }, _cache[16] || (_cache[16] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                        ]), 8, _hoisted_42)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  ref: "submitButton",
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Enregistrer les modifications ", 8, _hoisted_45),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewCommandeFournisseurPage', params: { id: _ctx.commandeId } },
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}